module.exports = __webpack_public_path__ + "img/14.babd56b6.png";